//
//
//
//
//
//

export default {
    name: 'Background',

    // props: ['image', 'overlay', 'opacity', 'blur'],
    props: {
        image: String,
        className: String,
        overlay: {

        },
        opacity: {},
        blur: {},
    },

    data(){ return {
        css: {
            minHeight : '100%'
        }
    }}
}
